import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subscribeToBot } from "../../../state/actions/catalogue";
import { useNavigate } from "react-router-dom";
import { setHeaderTitle } from "../../../state/actions/layout";
import { setSelectedBot } from "../../../state/actions/domain";
import { createChatBotConversation } from "../../../state/actions/chats";
import { getAuthData } from "../../../services/storage/LocalStorage";

import CatalogBotsView from "../CatalogView/BotsView";
import BotModal from "../botModal";
import { setBotWaitLoader, setBotWaitLoaderWithShimmer } from "../../../state/actions/loader";


const CatalogBotsContainer = ({ bots = [], slide, botHolderStyle }) => {
	const botSubscriptions = useSelector((state) => state.user?.botSubscriptions || []);
	const selectedDomain = useSelector((state) => state.selectedDomain);
	const userDomain = selectedDomain?.userDomain || "";

	const [catalog, setCatalog] = useState([]);
	const [botToView, setBotToView] = useState(null);
	const [installingBotId, setInstallingBotId] = useState(null);


	const authData = getAuthData();
	const user = authData?.user || null;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (botSubscriptions && bots) {
			mergeWithSubscriptions(botSubscriptions, bots);
		}
	}, [botSubscriptions, bots]);

	const mergeWithSubscriptions = (subscriptions, allBots) => {
		const botSubscriptionIds = subscriptions.map((sub) => sub.botId);
		const updatedBots = allBots.map((bot) => ({
			...bot,
			subscribed: botSubscriptionIds.includes(bot.botId),
		}));
		setCatalog(updatedBots);
	};


	const handleCreateConversation = async (convBot) => {
		if (!convBot) return;

		if (!convBot.customFrontEnd) {
			dispatch(createChatBotConversation(convBot, user?.userId));
		}
		dispatch(setHeaderTitle(convBot?.botName));
		dispatch(setSelectedBot(convBot));
		dispatch(setBotWaitLoader(true));
		dispatch(setBotWaitLoaderWithShimmer(true));
		navigate("/app/chats");
	};

	const handleOpenBot = (bot) => {
		setBotToView(bot);
	};

	const handleCloseBot = () => {
		setBotToView(null);
	};

	const handleSubscribeToBot = async (botId) => {
		setInstallingBotId(botId);
		const apiRespone = await dispatch(subscribeToBot(botId));
		if (apiRespone) setInstallingBotId(null);
	};

	return (
		<>
			<CatalogBotsView
				bots={catalog}
				botHolderStyle={botHolderStyle}
				subscribeToBot={handleSubscribeToBot}
				createConversation={handleCreateConversation}
				openBot={handleOpenBot}
				userDomain={userDomain}
				installingBotId={installingBotId}
			/>
			{botToView && (
				<BotModal
					bot={botToView}
					close={handleCloseBot}
					subscribeToBot={(botId) => dispatch(subscribeToBot(botId))}
					createConversation={handleCreateConversation}
					userDomain={userDomain}
				/>
			)}
		</>
	);
};

export default CatalogBotsContainer;
